import { Button } from 'primereact/button'
import { Checkbox } from 'primereact/checkbox'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { ToastContent, toast } from 'react-toastify'
import { addUsersData } from 'services/userService'
import { PERMISSION_DENIED_MESSAGE } from "../../constants/index";
import { useDispatch } from 'react-redux'
import { handleLoader } from 'redux/counterSlice'

const AddUpdateUsers = ({ firstName, lastName, email, add, edit }: { firstName: string, lastName: string, email: string, add: boolean, edit: boolean }) => {

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm<any>()

    const params = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const getFormErrorMessage = (name: string) => {
        return (
            errors[name] && (
                <small className="p-error">{errors[name]?.message?.toString()}</small>
            )
        )
    }

    useEffect(() => {
        setValue("firstName", firstName)
        setValue("lastName", lastName)
        setValue("email", email)
    }, [email, firstName, lastName, setValue])

    const onSubmit = async (data: { email: string, firstName: string, lastName: string }) => {
        dispatch(handleLoader(true));
        try {
            let result: any
            if (params.id !== "add" && edit) {
                result = await addUsersData({ ...data, update: true })
            } else if (params.id === "add" && add) {
                result = await addUsersData({ ...data, update: false })
            } else {
                toast.error(PERMISSION_DENIED_MESSAGE, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }

            if (result?.result?.error) {
                throw result.result.error
            }
            dispatch(handleLoader(false));
            toast.success(result.result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            navigate("/admin/users")
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="group-form">
            <div className='form-row'>
                <div className='form-col'>
                    <label className="form-label">First Name<i>*</i></label>
                    <div>
                        <InputText
                            className="form-control"
                            {...register("firstName", {
                                required: {
                                    value: true,
                                    message: "First name is required",
                                },
                            })}
                            placeholder="First Name"
                        />
                    </div>
                    {getFormErrorMessage("firstName")}
                </div>
            </div>
            <div className='form-row'>
                <div className='form-col'>
                    <label className="form-label">Last Name<i>*</i></label>
                    <div>
                        <InputText
                            className="form-control"
                            {...register("lastName", {
                                required: {
                                    value: true,
                                    message: "Last name is required",
                                },
                            })}
                            placeholder="Last Name"
                        />
                    </div>
                    {getFormErrorMessage("lastName")}
                </div>
            </div>
            <div className='form-row'>
                <div className='form-col'>
                    <label className="form-label">Email<i>*</i></label>
                    <div>
                        <InputText
                            className="form-control"
                            type="email"
                            {...register('email', {
                                required: 'Email is required',
                                pattern: {
                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: "Invalid email address"
                                },
                            })}
                            placeholder="Email"
                            disabled={params.id !== "add"}
                        />
                    </div>
                    {getFormErrorMessage("email")}
                </div>
            </div>
            <div className="col-12">
                <Button
                    type="button"
                    className="outline-icon-btn mr-3"
                    onClick={() => {
                        navigate("/admin/users")
                    }}
                >
                    Cancel
                </Button>
                <Button className="outline-active-btn mr-3" type="submit">
                    Save
                </Button>
            </div>
        </form>
    )
}

export default AddUpdateUsers